import "../../CSS/layout/header.css";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Logo from "../../assets/HomePage/logo1.svg";
import { categories, productsIn } from "../ProductPage/products";
import { PHONE, PHONE_LINK } from "./contactInfo";

function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Close menus whenever the page changes.
  useEffect(() => {
    setMenuOpen(false);
    setProductsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const productPaths = categories.flatMap((c) => productsIn(c.id).map((p) => p.path));
  const onProductPage =
    location.pathname === "/ourproducts" || productPaths.includes(location.pathname);

  return (
    <header
      className={`dm-header ${scrolled || menuOpen ? "is-scrolled" : ""} ${menuOpen ? "menu-open" : ""}`}
    >
      <div className="dm-container dm-header-inner">
        <Link to="/" className="dm-header-logo" aria-label="Delmen Mosquito Screens home">
          <img src={Logo} alt="Delmen Mosquito Screens" width="132" height="40" />
        </Link>

        <nav className="dm-nav" aria-label="Main">
          <NavLink to="/" end className="dm-nav-link">
            Home
          </NavLink>
          <div
            className={`dm-nav-dropdown ${productsOpen ? "open" : ""}`}
            onMouseEnter={() => setProductsOpen(true)}
            onMouseLeave={() => setProductsOpen(false)}
          >
            <button
              type="button"
              className={`dm-nav-link ${onProductPage ? "active" : ""}`}
              aria-expanded={productsOpen}
              onClick={() => setProductsOpen(!productsOpen)}
            >
              Products <ExpandMoreIcon className="dm-nav-caret" />
            </button>
            <div className="dm-mega">
              <div className="dm-mega-grid">
                {categories.map((category) => (
                  <div key={category.id}>
                    <p className="dm-mega-title">{category.name}</p>
                    <ul>
                      {productsIn(category.id).map((product) => (
                        <li key={product.path}>
                          <Link to={product.path}>{product.name}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <Link to="/ourproducts" className="dm-mega-all">
                View all products →
              </Link>
            </div>
          </div>
          <NavLink to="/companyprofile" className="dm-nav-link">
            Company
          </NavLink>
          <NavLink to="/Readmore" className="dm-nav-link">
            Why Delmen
          </NavLink>
          <NavLink to="/contactus" className="dm-nav-link">
            Contact
          </NavLink>
        </nav>

        <div className="dm-header-actions">
          <a href={PHONE_LINK} className="dm-header-phone">
            <CallIcon /> {PHONE}
          </a>
          <Link to="/contactus" className="dm-btn dm-btn-primary dm-btn-sm">
            Get a Quote
          </Link>
          <button
            type="button"
            className="dm-menu-btn"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="dm-mobile-menu">
          <nav className="dm-container" aria-label="Mobile">
            <NavLink to="/" end className="dm-mobile-link">
              Home
            </NavLink>
            <NavLink to="/ourproducts" className="dm-mobile-link">
              All Products
            </NavLink>
            {categories.map((category) => (
              <details key={category.id} className="dm-mobile-group">
                <summary>
                  {category.name}
                  <ExpandMoreIcon />
                </summary>
                <ul>
                  {productsIn(category.id).map((product) => (
                    <li key={product.path}>
                      <Link to={product.path}>{product.name}</Link>
                    </li>
                  ))}
                </ul>
              </details>
            ))}
            <NavLink to="/companyprofile" className="dm-mobile-link">
              Company
            </NavLink>
            <NavLink to="/Readmore" className="dm-mobile-link">
              Why Delmen
            </NavLink>
            <NavLink to="/contactus" className="dm-mobile-link">
              Contact
            </NavLink>
            <div className="dm-mobile-actions">
              <Link to="/contactus" className="dm-btn dm-btn-primary">
                Get a Quote
              </Link>
              <a href={PHONE_LINK} className="dm-btn dm-btn-outline">
                <CallIcon /> Call {PHONE}
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}

export default SiteHeader;
